<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            USUÁRIO -
                            <b-badge variant="warning">{{ operacao }}</b-badge>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <app-k-v titulo="Status" :md="3" :lg="2" :xl="1">
                            <app-status
                                :status="usuario.statusDescr"
                            ></app-status>
                        </app-k-v>
                        <app-k-v
                            titulo="Login"
                            :md="3"
                            :lg="2"
                            :xl="1"
                            :dado="usuario.login"
                        ></app-k-v>
                        <app-k-v
                            titulo="Nome"
                            :md="3"
                            :lg="2"
                            :xl="1"
                            :dado="usuario.nome"
                        ></app-k-v>
                        <app-k-v
                            titulo="Email"
                            :md="3"
                            :lg="2"
                            :xl="1"
                            :dado="usuario.email"
                        ></app-k-v>
                        <app-k-v
                            v-if="fornecedor || gestaoInterna"
                            titulo="Telefone"
                            :md="3"
                            :lg="2"
                            :xl="1"
                            :dado="usuario.telefone01"
                        ></app-k-v>
                        <app-k-v
                            v-if="fornecedor || gestaoInterna"
                            titulo="Celular"
                            :md="3"
                            :lg="2"
                            :xl="1"
                            :dado="usuario.telefone02"
                        ></app-k-v>
                        <app-k-v
                            titulo="Última Atualização"
                            :md="3"
                            :lg="2"
                            :xl="1"
                            :dado="usuario.dataAtualizacao"
                            tipo="datetime"
                        ></app-k-v>
                    </b-card-body>
                    <b-card-footer>
                        <b-button
                            variant="primary"
                            v-if="mostrarBtnAtualizar"
                            @click.stop="transferirParaAtualizacao()"
                            class="mr-2"
                        >
                            <i class="fa fa-edit"></i> Atualizar
                        </b-button>
                        <app-usuario-resetar-senha
                            :usuario="usuario"
                            v-if="mostrarBtnResetarSenha"
                            :fornecedor="fornecedor"
                            :gestaoInterna="gestaoInterna"
                        ></app-usuario-resetar-senha>
                        <app-usuario-ativar-desativar
                            :usuario="usuario"
                            @obterUsuario="obterUsuario()"
                            v-if="mostrarBtnAtivarDesativar"
                            :fornecedor="fornecedor"
                            :gestaoInterna="gestaoInterna"
                        ></app-usuario-ativar-desativar>
                        <b-button variant="danger" @click.stop="voltar()">
                            <span>
                                <i class="fa fa-history mr-2"></i> Voltar
                            </span>
                        </b-button>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
        <b-row
            v-if="
                $temAcessoView('CTRLACS-USR-06') ||
                $temAcessoView('FORN-USR-06') ||
                $temAcessoView('GEST-FORNECEDORES-02')
            "
        >
            <b-col sm="12">
                <app-usuario-perfis-acesso
                    :usuario="usuario"
                    :gestaoInterna="gestaoInterna"
                    @obterUsuario="obterUsuario()"
                ></app-usuario-perfis-acesso>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import UsuariosServicos from './UsuariosServicos'
import UsuariosFornecedorServicos from './UsuariosFornecedorServicos'
import FornecedoresUsuariosServicos from './../../fornecedor/usuarios/UsuariosServicos'
import UsuarioPerfisAcesso from './UsuarioPerfisAcesso'
import UsuarioResetarSenha from './UsuarioResetarSenha'
import UsuarioAtivarDesativar from './UsuarioAtivarDesativar'

export default {
    props: {
        gestaoInterna: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            usuario: {},
            fornecedor: false,
            operacao: 'DETALHAR'
        }
    },

    methods: {
        voltar() {
            if (this.fornecedor) {
                this.$router.push({ name: 'Fornecedores_Usuarios' })
            } else if (this.gestaoInterna) {
                this.$router.push({ name: 'UsuariosFornecedor' })
            } else {
                this.$router.push({ name: 'Usuarios' })
            }
        },

        obterUsuario() {
            this.$store.dispatch('addRequest')
            let promisse
            if (this.fornecedor) {
                promisse = FornecedoresUsuariosServicos.obterPorId(
                    this.$route.params.usuarioId
                )
            } else if (this.gestaoInterna) {
                promisse = UsuariosFornecedorServicos.obterPorId(
                    this.$route.params.fornecedorId,
                    this.$route.params.usuarioId
                )
            } else {
                promisse = UsuariosServicos.obterPorId(
                    this.$route.params.usuarioId
                )
            }
            promisse.then((response) => {
                if (response) {
                    if (response.success) {
                        this.usuario = response.data
                        if (this.fornecedor || this.gestaoInterna) {
                            this.usuario.telefone01 = this.$mask(
                                this.usuario.telefone01,
                                ['(##) ####-####', '(##) #####-####']
                            )
                            this.usuario.telefone02 = this.$mask(
                                this.usuario.telefone02,
                                ['(##) ####-####', '(##) #####-####']
                            )
                        }
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        transferirParaAtualizacao() {
            if (this.fornecedor) {
                this.$router.push({
                    name: 'Fornecedores_Usuarios_Atualizar',
                    params: { usuarioId: this.$route.params.usuarioId }
                })
            } else if (this.gestaoInterna) {
                this.$router.push({
                    name: 'UsuariosFornecedor_Atualizar',
                    params: { usuarioId: this.$route.params.usuarioId }
                })
            } else {
                this.$router.push({
                    name: 'Usuarios_Atualizar',
                    params: { usuarioId: this.$route.params.usuarioId }
                })
            }
        }
    },

    computed: {
        mostrarBtnAtualizar() {
            return (
                this.$temAcessoView('FORN-USR-03') ||
                this.$temAcessoView('GEST-FORNECEDORES-02')
            )
        },

        mostrarBtnResetarSenha() {
            return (
                (this.fornecedor && this.$temAcessoView('FORN-USR-04')) ||
                this.$temAcessoView('GEST-FORNECEDORES-02')
            )
        },

        mostrarBtnAtivarDesativar() {
            return (
                this.$temAcessoView('CTRLACS-USR-05') ||
                this.$temAcessoView('FORN-USR-05') ||
                this.$temAcessoView('GEST-FORNECEDORES-02')
            )
        }
    },

    created() {
        if (this.$store.getters.fornecedor.fornecedorId) {
            this.fornecedor = true
        }
        this.obterUsuario()
    },

    components: {
        AppUsuarioPerfisAcesso: UsuarioPerfisAcesso,
        AppUsuarioResetarSenha: UsuarioResetarSenha,
        AppUsuarioAtivarDesativar: UsuarioAtivarDesativar
    }
}
</script>
